import template from './swag-cms-extensions-block-behavior-config.html.twig';

/**
 * @deprecated tag:v6.0.0 - Will be removed
 */
export default {
    template,
    props: {
        block: {
            type: Object,
            required: true,
            default() {
                return {};
            },
        },
    },
    computed: {
        blockRuleFeatureActive() {
            return true;
        },
        quickviewFeatureActive() {
            return true;
        },
    },
}
